import { AssetCategory } from "./AssetCategory";

export const AssetCategoryPresets: Record<string, AssetCategory> = {
  all: AssetCategory.all,
  models:
    AssetCategory.bim |
    AssetCategory.cad |
    AssetCategory.pointcloud |
    AssetCategory.scanset |
    AssetCategory.gis |
    AssetCategory.raster,
  documents:
    AssetCategory.image |
    AssetCategory.pdf |
    AssetCategory.zip |
    AssetCategory.autodesk |
    AssetCategory.other,
  layers: AssetCategory.layer,
};
